import React, { useCallback, useState } from 'react';
import { numberWithCommas } from 'shared/utils/numberUtils';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import BudgetDonationsModalContent, {
  BudgetDonationFieldErrors,
} from './BudgetDonationsModalContent';
import { dollarAmountDefaultValue } from 'shared/design-system/components/TrueImpactDollarField';

interface BudgetDonationsModalProps {
  reportId: number | string;
  open: boolean;
  title: string;
  handleClose: () => unknown;
  setDonations: (d: string) => unknown;
}

const BudgetDonationsModal: React.FC<BudgetDonationsModalProps> = ({
  open,
  title,
  reportId,
  handleClose,
  setDonations,
}) => {
  const [errors, setErrors] = useState<BudgetDonationFieldErrors>({});
  const [prevErrors, setPrevErrors] = useState<BudgetDonationFieldErrors>({});
  const [total, setTotal] = useState<string>(dollarAmountDefaultValue);

  const handleChange = useCallback(
    (total: string, errors: BudgetDonationFieldErrors) => {
      setTotal(total);
      setErrors(errors);
    },
    [setTotal, setErrors],
  );

  const handleSetCost = useCallback(() => {
    if (Object.keys(errors).length === 0) {
      handleClose();
      setDonations(numberWithCommas(total));
      setPrevErrors([]);
    } else {
      setPrevErrors(errors);
    }
  }, [total, errors, handleClose, setDonations, setPrevErrors]);

  return (
    <TrueImpactModal
      open={open}
      keepMounted={true}
      onClose={handleClose}
      title={title}
      next={{
        text: 'Add total to report',
        onClick: handleSetCost,
      }}
      previous={{
        text: 'Cancel',
        onClick: handleClose,
      }}
    >
      <BudgetDonationsModalContent
        total={total}
        errors={prevErrors}
        reportId={reportId}
        handleTotal={handleChange}
      />
    </TrueImpactModal>
  );
};

export default BudgetDonationsModal;
